import React, { memo, useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Button } from "../../../components";
import { AppContext } from "../../../components/AppProvider";
import HeaderNavigate from "../../../components/UI/Header/HeaderNavigate";
import Labels from "../../../components/UI/Label/Labels";
import { stringToTelNo } from "../../../modules/utils/CheckLogic";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { IC } from "../../../resources/Assets";
import { closeLayerFn, openLayerFn } from "../../Layout";

export const NaverMapAPI = props => {
  const {
    locationInfo,
    popupType,
    zoomControl,
    customControl,
    mapId,
    size,
    draggable,
  } = props;
  // const [zoomLevel, setZoomLevel] = useState(18);
  let zoomLevel = 18;
  const { phonecfg } = useContext(AppContext);
  const [mapDraw, setMapDraw] = useState(false);

  let lat = "";
  let lon = "";

  if (popupType == "PF") {
    lat = locationInfo.latitude;
    lon = locationInfo.longitude;
  } else {
    lat = locationInfo.latitude;
    lon = locationInfo.longitude;
  }

  // 사용자 커스텀 버튼
  const locationBtnHtml =
    '<div style="position: absolute; left: 16px; bottom:' +
    (locationInfo && locationInfo.receiptUseType ? 130 : 110) +
    'px; -webkit-tap-highlight-color: rgba(0,0,0,0)">' +
    '<a><span class="spr_trff spr_ico_mylct"><img src="' +
    IC.etc.ICON_LOCATION_ITEM +
    '" style="width: 48px; height: 48px; border-radius: 50%; box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08"/></span></a>' +
    "</div>";

  const customZoomBtn =
    "<div style='position: absolute; display: flex; flex-flow: column; right: 16px; bottom: " +
    (locationInfo && locationInfo.receiptUseType ? 140 : 120) +
    "px; box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08)'>" +
    '<img id="add" src="' +
    IC.map.ICON_MAP_ZOOM_PLUS +
    '" style="width: 45px; height: 45px"/>' +
    '<img id="min" src="' +
    IC.map.ICON_MAP_ZOOM_MINUS +
    '" style="width: 45px; height: 45px"/>' +
    "</div>";

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  });

  useEffect(() => {
    let map = new naver.maps.Map(mapId ? mapId : "map");

    if (!window.naver) return;
    // if (Object.keys(locationInfo).length > 0 && !mapDraw) {
    if (Object.keys(locationInfo).length > 0) {
      // 네이버지도 옵션 셋팅(좌표, 기본확대)
      let mapOptions = {
        center: new naver.maps.LatLng(lat, lon),
        scaleControl: false,
        logoControl: false,
        mapDataControl: false,
        zoom: zoomLevel,
        // zoomControl: zoomControl ? true : false,
        zoomControl: false,
        zoomControlOptions: {
          style: naver.maps.ZoomControlStyle.SMALL,
          // position: naver.maps.Position.TOP_RIGHT,
          position: naver.maps.Position.RIGHT_BOTTOM,
        },
        logoControlOptions: {
          position: naver.maps.Position.RIGHT_TOP,
        },
        draggable: draggable,
      };

      map = new naver.maps.Map(mapId ? mapId : "map", mapOptions);

      // infoWindow DIV 세팅
      let contentString = setInfoWindowContent(popupType, locationInfo);

      // 네이버지도 Marker 옵션 셋팅
      let marker = new naver.maps.Marker({
        position: new naver.maps.LatLng(lat, lon),
        map: map,
        icon:
          popupType === "PH"
            ? IC.marker.ICON_MAP_PHARM_MARKER
            : IC.marker.ICON_MAP_HSPT_MARKER,
      });

      let myMarker = new naver.maps.Marker({
        position: new naver.maps.LatLng(phonecfg.userLat, phonecfg.userLng),
        map: map,
        icon: IC.marker.ICON_MAP_MY_MARKER,
      });

      let infowindow = new naver.maps.InfoWindow({
        content: contentString,
        maxWidth: 200,
        padding: 5,
      });

      // if (!props.marker || props.marker === "ON") {
      //   infowindow.open(map, marker);
      // }

      // if (customControl && !mapDraw) {
      if (customControl) {
        naver.maps.Event.once(map, "init", function () {
          //customControl 객체 이용하기
          var customControl = new naver.maps.CustomControl(locationBtnHtml, {
            position: naver.maps.Position.LEFT_BOTTOM,
          });
          customControl.setMap(null);
          customControl.setMap(map);

          naver.maps.Event.addDOMListener(
            customControl.getElement(),
            "click",
            function () {
              map.setCenter(
                new naver.maps.LatLng(phonecfg.userLat, phonecfg.userLng)
              );
            }
          );
        });
      }

      // if (zoomControl && !mapDraw) {
      if (zoomControl) {
        naver.maps.Event.once(map, "init", function () {
          //customControl 객체 이용하기
          var customControl = new naver.maps.CustomControl(customZoomBtn, {
            position: naver.maps.Position.RIGHT_BOTTOM,
          });

          customControl.setMap(map);

          naver.maps.Event.addDOMListener(
            customControl.getElement(),
            "click",
            function (e) {
              if (e.target.id === "add") {
                if (zoomLevel < 19) {
                  zoomLevel = zoomLevel + 1;
                  map.setZoom(zoomLevel + 1);
                }
              } else {
                if (zoomLevel > 16) {
                  zoomLevel = zoomLevel - 1;
                  map.setZoom(zoomLevel);
                }
              }
            }
          );
        });
      }

      var Size = new naver.maps.Size(
        size ? size.width : window.innerWidth,
        size ? size.height : window.innerHeight - 171
      );

      map.setSize(Size);

      naver.maps.Event.removeListener();

      setMapDraw(true);
    }
  }, [locationInfo]);

  return (
    <div
      id={mapId ? mapId : "map"}
      style={{ width: "100vw", height: "100%", borderRadius: "4px" }}></div>
  );
};

export const MapView = memo(props => {
  const { selectHpNm, hpLat, hpLon, locationInfo, popupType, backTopColor } =
    props;
  const { phonecfg } = useContext(AppContext);

  const BottomHeight = useRef(null);

  const fn_dataSharing = () => {
    // let sharingData = {
    //     hpName:'',
    //     addr:'',
    //     url:''
    // };

    let addrInfo = "";
    let lat = "";
    let lon = "";
    let sharingData = "";
    let hsptName = "";

    if (popupType === "PF") {
      addrInfo =
        locationInfo.address3 +
        " " +
        locationInfo.address4 +
        " " +
        locationInfo.hsptNm;
      lat = locationInfo.latitude;
      lon = locationInfo.longitude;
      hsptName = locationInfo.hsptNm;
    } else if (popupType === "PH") {
      addrInfo =
        locationInfo.address3 +
        " " +
        locationInfo.address4 +
        " " +
        locationInfo.phName;
      lat = locationInfo.latitude;
      lon = locationInfo.longitude;
      hsptName = locationInfo.phName;
    } else if (popupType === "HSPT") {
      addrInfo =
        locationInfo.address3 +
        " " +
        locationInfo.address4 +
        " " +
        locationInfo.phName;
      lat = locationInfo.latitude;
      lon = locationInfo.longitude;
      hsptName = locationInfo.hsptNm;
    } else {
      addrInfo =
        locationInfo.address3 +
        " " +
        locationInfo.address4 +
        " " +
        locationInfo.hpName;
      lat = locationInfo.latitude;
      lon = locationInfo.longitude;
      hsptName = locationInfo.hpName;
    }

    sharingData =
      "nmap://map" +
      "?lat=" +
      lat +
      "&lng=" +
      lon +
      "&name=" +
      encodeURI(hsptName) +
      "&zoom=" +
      "18";

    NativeAction(phonecfg, "share", sharingData);
  };

  return (
    <div
      className="blacklayer-container map-view-layer"
      style={{ zIndex: "99999", width: "100vw", maxWidth: "100vw" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div
          className="his-detail-layerbox bgblk"
          style={{ background: "#fff" }}>
          <div style={{ width: "100vw" }} id="mapLayerHeader">
            <HeaderNavigate
              leftIcon={{
                imgSrc: IC.etc.ICON_CHEVRON_LEFT,
                action: () => {
                  closeLayerFn($(".map-view-layer"));
                  NativeAction(
                    phonecfg,
                    "statusColor",
                    backTopColor ? backTopColor : "#b2bee6"
                  );
                },
              }}
              headerTitle={
                popupType === "PH"
                  ? locationInfo.phName
                  : locationInfo.hsptNm
                  ? locationInfo.hsptNm
                  : locationInfo.hpName
              }
            />
          </div>
          <div className="map-box" style={{ height: "calc(100% - 171px)" }}>
            <div className="map-area">
              <div id="mapContainer" style={{ height: "100%" }}>
                <NaverMapAPI
                  lat={hpLat}
                  lon={hpLon}
                  locationInfo={locationInfo}
                  popupType={popupType}
                  zoomControl={true}
                  customControl={true}
                  draggable={true}
                />
              </div>
            </div>
          </div>
        </div>

        <BottomSheet ref={BottomHeight} id="mapLayerBottom">
          <Body>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "16px",
              }}>
              <div
                style={
                  popupType != "PH"
                    ? { width: "calc(100vw - 136px)" }
                    : { width: "calc(100vw - 40px)" }
                }>
                <span style={{ fontWeight: "600", fontSize: "16px" }}>
                  {popupType === "PH"
                    ? locationInfo.phName
                    : locationInfo.hsptNm
                    ? locationInfo.hsptNm
                    : locationInfo.hpName}
                </span>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "flex-start",
                  }}>
                  {locationInfo.distance && (
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: "12px",
                        letterSpacing: "-0.24px",
                        whiteSpace: "nowrap",
                      }}>
                      {locationInfo.distance}
                    </span>
                  )}
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "rgb(136, 136, 136)",
                      letterSpacing: "-0.24px",
                      whiteSpace: "break-spaces",
                    }}>
                    {locationInfo.address3}
                  </span>
                </div>
                <div>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "rgb(136, 136, 136)",
                    }}>
                    {stringToTelNo(locationInfo.phone)}
                  </span>
                </div>
              </div>
              {popupType != "PH" && (
                <div
                  style={{
                    display: "flex",
                    backgroundColor: "#f7f7fa",
                    width: "80px",
                    height: "80px",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "4px",
                  }}>
                  <img
                    src={IC.etc.ICON_HSPT_DEFAULT}
                    style={{ width: "41px", height: "53px" }}
                  />
                </div>
              )}
            </div>

            {locationInfo &&
              (locationInfo.receiptUseType || locationInfo.hpTypeNm) && (
                <div>
                  <Labels
                    labels={[
                      (locationInfo.receiptUseType.toString() === "2" ||
                        locationInfo.receiptUseType.toString() === "9") && {
                        status: "active_green",
                        leftIcon: IC.camera.ICON_CAMERA_GREEN,
                        text: "비대면진료",
                      },
                      locationInfo.hpTypeNm &&
                        locationInfo.hpTypeNm != undefined &&
                        locationInfo.hpTypeNm != null &&
                        locationInfo.hpTypeNm != "" && {
                          status: "default",
                          text: locationInfo.hpTypeNm,
                        },
                    ]}
                  />
                </div>
              )}
          </Body>
          <Bottom>
            <Button
              severity={"primary"}
              disable={locationInfo.phone ? "off" : "on"}
              clickEvent={e =>
                locationInfo.phone
                  ? (location.href = "tel:" + locationInfo.phone)
                  : e.preventDefault()
              }>
              전화문의
            </Button>
          </Bottom>
        </BottomSheet>
      </div>
    </div>
  );
});

export const mapLayer = (phonecfg, setLocationInfo, locationInfo) => {
  setLocationInfo(locationInfo);
  NativeAction(phonecfg, "statusColor", "#FFFFFF");
  openLayerFn($(".map-view-layer"));
};

const setInfoWindowContent = (popupType, locationInfo) => {
  let contentString = [];

  if (popupType === "PF") {
    contentString = [
      '<div class="iw_inner" style="margin:5px">',
      "   <h3>",
      locationInfo.hsptNm,
      "   </h3>",
      "   <p>",
      locationInfo.address3 + " " + locationInfo.address4,
      "   </p>",
      '   <p style="text-align:right">',
      stringToTelNo(locationInfo.phone),
      "   </p>",
      "</div>",
    ].join("");
  } else if (popupType === "PH") {
    contentString = [
      '<div class="iw_inner" style="margin:5px">',
      "   <h3>",
      locationInfo.phName,
      "   </h3>",
      "   <p>",
      locationInfo.address3 + " " + locationInfo.address4,
      "   </p>",
      "</div>",
    ].join("");
  } else {
    if (locationInfo.phone) {
      contentString = [
        '<div class="iw_inner" style="margin:5px">',
        "   <h3>",
        locationInfo.hpName,
        "   </h3>",
        "   <p>",
        locationInfo.address3 + " " + locationInfo.address4,
        "   </p>",
        '   <p style="text-align:right">',
        stringToTelNo(locationInfo.phone),
        "   </p>",
        "</div>",
      ].join("");
    } else {
      contentString = [
        '<div class="iw_inner" style="margin:5px">',
        "   <h3>",
        locationInfo.hpName,
        "   </h3>",
        "   <p>",
        locationInfo.address3 + " " + locationInfo.address4,
        "   </p>",
        "</div>",
      ].join("");
    }
  }

  return contentString;
};

const BottomSheet = styled.div`
  z-index: 999;
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  /* background: green; */
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  border-radius: 16px 16px 0px 0px;
  padding-top: 32px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
`;

const Body = styled.div`
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0px 20px;
`;

const Bottom = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 24px 20px;
`;
